module.exports = __webpack_public_path__ + "img/real-madrid.a59d8184.png";